<template>
  <div class="orderCenter clearfix">
    <div class="titleBox">
      <h2 class="m-0">
        <span class="cursor" @click="qiehuanTypeFun(1)" :class="{active:type===1?'active':''}">优惠券</span>
        <span class="cursor" @click="qiehuanTypeFun(2)" :class="{active:type===2?'active':''}">满减</span>
        <span class="cursor" @click="qiehuanTypeFun(3)" :class="{active:type===3?'active':''}">直降</span>
        <span class="cursor" @click="qiehuanTypeFun(4)" :class="{active:type===4?'active':''}">折扣</span>
        <button @click='toBack' class="btn btn-outline-dark btn-round d-block d-lg-none">商城 <i class="iconfont icon-qianwang"></i></button>
      </h2>
      <hr>
      <div v-if="type===1">
        <span @click="qiehuanUseFun(1)" :class="{'btn-dark':use===1}" class="btn-sm btn btn-default btn-round">待使用</span>
        <span @click="qiehuanUseFun(2)" :class="{'btn-dark':use===2}" class="btn-sm btn btn-default btn-round">已使用</span>
        <span @click="qiehuanUseFun(3)" :class="{'btn-dark':use===3}" class="btn-sm btn btn-default btn-round">已过期</span>
      </div>
    </div>
    <div class="jiazaiBox" v-if="is_loading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="orderBox">
      <div v-if="!is_loading && data.length!==0" class="box">
        <div class="row">
          <div v-for="(app,index) in data" :key="index" class="col-12 col-sm-6">
            <div class="cards" :class="{'none':use!==1}">
              <div class="cards-left">{{app.bigTitle}}<small>{{app.smallTitle}}</small></div>
              <div class="cards-right">
                <p class="cards-info">{{app.title}}</p>
                <strong class="cards-time">{{app.startTime}} - {{app.endTime}}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!is_loading && data.length===0" class="description text-center emptyBox">
        <br>
        <br>
        <i class="iconfont icon-wushuju2"></i>
        <br>
        <br>
        <br>
      </div>
    </div>
    <div><br><br><br><br><br><br><br><br><br><br><br><br><br></div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import resultcommons from '../../util/resultcommons';
// import resultCommons from '@/util/resultcommons';

export default {
  name: 'orderCenter',
  mixins: [generalMix],
  data () {
    return {
      type:1,
      use:1,
      is_loading:true,
      data:[]
    }
  },
  computed:{
    whereObj() {
      return {
        type: this.type,
        use: this.use
      };
    }
  },
  components: {
  },
  methods:{
    qiehuanTypeFun(type) {
      if(type !== this.type){
        this.type = type;
        this.use = 1;
        this.sendActivitylists();
      }
    },
    qiehuanUseFun(use) {
      if(use !== this.use){
        this.use = use;
        this.sendActivitylists();
      }
    },
    sendActivitylists() {
      this.is_loading = true;
      this.data = [];
      resultcommons.apiActivityinfoalls(this,this.whereObj).then(app=>{
        if(app.state === 200){
          this.data = app.data;
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: 'app.message'
          });
        }
        this.is_loading = false;
      });
    }
  },
  created() {
    this.sendActivitylists();
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.orderCenter {
  div.orderBox{
    overflow: hidden;
    min-height: 90vh;
    div.emptyBox{
      i{
        font-size: 36px;
      }
    }
    div.box{
      .cards{
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        background: #F8D7DA;
        border-radius: 8px;
        /*其他样式*/
        -webkit-mask-image: radial-gradient(circle at 100px 4px, transparent 4px, red 4.5px), radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
        -webkit-mask-size: 100%, 2px 4px;
        -webkit-mask-repeat: repeat, repeat-y;
        -webkit-mask-position: 0 -4px, 99px;
        -webkit-mask-composite: source-out;
        mask-composite: subtract;
        border: 1px solid #F8D7DA;
        &.none{
          background: #E2E3E5;
          border-color: #E2E3E5;
        }
      }
      .cards-left{
        width: 100px;
        text-align: center;
        font-size: 18px;
        color: #F51449;
        font-weight: bold;
        small{
          font-size: 12px;
          display: block;
          color: #000000;
        }
      }
      .cards-left span{
        font-size: 10px;
      }
      .cards-right{
        padding: 16px 12px;
        display: flex;
        flex: 1;
        flex-direction: column;
      }
      .cards-info{
        margin: 0;
        font-size: 14px;
        line-height: 20px;
        color: rgba(33, 32, 44, 0.9);
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-weight: bold;
      }
      .cards-time{
        font-size: 12px;
        line-height: 16px;
        font-weight: normal;
        color: #F51449;
        margin-top: 4px;
        color: #856404;
      }
    }
  }
  .titleBox {
    margin-top: 30px;
    margin-bottom: 30px;
    h2{
      span{
        margin-left: 10px;
        font-size: 18px;
        color: #999999;
        &.active{
          font-size: 2rem;
          color: #000000;
        }
        &:first-child{
          margin: 0;
        }
      }
    }
    p {
      margin: 0;
    }
  }
  div.jiazaiBox{
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    min-height: 250px;
    .spinner-border{
      width: 3rem;
      height: 3rem;
      color: red;
    }
  }
  div.emptyBox{
    background: #FFFFFF;
    min-height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
    i{
      font-size:86px;
    }
  }
  @media (max-width: 992px) {
    .titleBox {
      margin-top: 0;
      h2{
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        span{
          line-height: 36px;
          margin: 0;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .titleBox {
      text-align: center;
      p{
        padding: 0 15px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/coupon/Center.vue